import React from 'react';
import factory from 'components/Icons/factory';

export const Search = factory(
  'Search',
  <path d="M117.2 109.8L90.7 83.3c15.9-19.6 13-48.3-6.6-64.2s-48.3-13-64.2 6.6-13 48.3 6.6 64.2c16.5 13.4 40 13.7 56.8.7l26.5 26.7c2 2.1 5.3 2.1 7.4 0 2-2 2.1-5.3 0-7.5zm-97.5-55c.1-19.4 15.9-35 35.2-34.9 19.4.1 35 15.9 34.9 35.2C89.7 74.4 74 90 54.7 90s-35-15.8-35-35.2z" />
);

export default Search;
